import { TextAreaField } from 'lib/iterable-hook-form';
import { INTEGRATION_FORM_CONTENT } from 'modules/mobileApps/constants';
import {
  IntegrationFormField,
  useIntegrationFormContext,
} from 'modules/mobileApps/context/integrationForm';
import { FormField } from 'ui/formField';
import { Label } from 'ui/theme';
import { getFormErrorMessages } from '../../utils';
import { EnvironmentRadioList } from '../components';

const { inputs, name } = INTEGRATION_FORM_CONTENT.authMethods.pemCertificate;

export const PEMFormPart = () => {
  const {
    formState: { errors },
  } = useIntegrationFormContext();

  const errorMessages = getFormErrorMessages(errors);

  return (
    <>
      <Label>{name}</Label>
      <FormField errorText={errorMessages.certificate} hasError={!!errorMessages.certificate}>
        <TextAreaField
          data-test={`input-${inputs.certificate.id}`}
          hasIcon={false}
          name={IntegrationFormField.certificate}
          placeholder={inputs.certificate.placeholder}
        />
      </FormField>
      <FormField errorText={errorMessages.privateKey} hasError={!!errorMessages.privateKey}>
        <TextAreaField
          data-test={`input-${inputs.privateKey.id}`}
          hasIcon={false}
          name={IntegrationFormField.privateKey}
          placeholder={inputs.privateKey.placeholder}
        />
      </FormField>
      <EnvironmentRadioList />
    </>
  );
};
